import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { Requests } from "../../api/IdentityServerRequests/Requests";
import { parse, format, parseISO } from 'date-fns';
import ErrorBanner from "../../hoc/ErrorBanner/ErrorBanner";
// Layout
import Tabs from "../../components/UI/Tabs/Tabs";
import MyScheduler from "../../components/MyScheduler/MyScheduler";
import MyDashboard from "../../components/MyScheduler/MyDashboard";
import AvailabilityTypeModal from '../../components/Availability/AvailabilityTypeModal'
import AvailabilityTemplateModal from "../../components/Availability/AvailabilityTemplateModal";
import AddAvailabilityForm from "../../components/Availability/AddAvailabilityForm";
import styles from "./MyAvailability.module.scss";
import Button from '../../components/UI/Button/Button';
import Loader from "../../components/UI/Loading/Loading";
import { Dropdown, DropdownMenu, DropdownItem, Menu, MenuItem, DropdownHeader, DropdownDivider } from "semantic-ui-react"
import mdtoast from "@dmuy/toast";
import Prompt from "../../components/UI/Popup/Prompt";
import { copyWeek } from "../../components/Availability/CopyPaste";
import { LeavePageConfirmation } from "./LeavePageConfirmation";
import { getOrdinalSuffix } from "../../utils/SharedUtils";
import MembersThreshold from "../../components/MyScheduler/MembersThreshold";


// Requests for API calls
import copy from "../../assets/copy/copy.json";
import ViewByModal from "../../components/Availability/ViewByModal";
import Icon from "../../components/UI/Icon/Icon";
import SetPagingGroupDropdown from "../../components/Availability/SetPagingGroupDropdown";
import Toggle from "../../components/UI/Button/Toggle";
import MultiSelectModal from "../../components/Availability/MultiSelectModal";
import SortByModal from "../../components/Availability/SortByModal";

/*
 * This is the paging group availability threshold section of Availability "dashboard",
 * It is the first of four tabs
 *
 * It shows paging group threshold met or not met
 * based off the criteria set in admin paging group details
 * ui/sasApp/sasAppReact/src/views/Admin/GroupDetailsView.jsx
 *
 * If nothing has been set, it will show not set in the title and description
 */

const scheduler = window.scheduler

export default class MyAvailabilityDBView extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.Requests = new Requests();
    this.state = {
      failedAPI: false,
      errorCode: null,
      width: window.innerWidth,
      height: window.innerHeight,
      ready: false,
      paramsId: null,
      currentTab: "",
      currentTabVal: null,
      currentTabNumber: null,
      details: {
        start: null,
      },
      callbackDate: null,
      date: null,
      day: null, // half hr view data
      dayLoading: false,
      results: null, // detail results
      resultsLoading: false,
      userPagingGroupsOption: [],
      userPagingGroupsOptionNoAV: [],
      pagingGroupsPartOfWithAvailability: {},
      onQualificationsTab: false, // If on Qualifications tab, no AV paging groups should be shown
      pagingGroupAgency: this.props.userAgencies.filter(e => e !== 'DYNAMIC')[0],
      pagingGroup: null, // If false, then the user has no paging groups
      defaultPagingGroup: null,
      thresholdReached: false,
      thresholdType: "ByPeople",
      thresholdByPeopleCount: 0,
      qualList: null,
      availabilityFormShowing: false,
      availabililtyTemplateModalShowing: false,
      availabilityTypeModalShowing: false,
      viewByModalShowing: false,
      selectedAvailabilityType: 'Available',
      selectedAvailabilityFilters: [],
      viewByRange: "Weekly",
      uncommittedChanges: [],
      clearUncommittedChanges: false,
      selectedGroups: [],
      selectedAgency: null,
      sortByFirstName: true,
      sortByAtoZ: true,
      sortByOption: copy.myAvailabilityScreen.membersAvailability.sortByOptions.alpha,
      sortByType: copy.myAvailabilityScreen.agencyAvailabilityTypes.default,
      requiredSkill1: {
        id: null,
        name: null,
        num: 0,
      },
      requiredSkill2: {
        id: null,
        name: null,
        num: 0,
      },
      requiredSkill3: {
        id: null,
        name: null,
        num: 0,
      },
      requiredSkill4: {
        id: null,
        name: null,
        num: 0,
      },
      requiredSkill5: {
        id: null,
        name: null,
        num: 0,
      },
      isMobileLandscapeMode: false,
      isLoading: false,
      clipboardFilled: window.sessionStorage.getItem("copiedAvailability") !== null,
      pagingGroupPayload: null,
      qualificationsToggle: false,
      qualifications: [],
      qualificationFavourites: [],
      isShowFormSOverride: false,
      isRcurring: false,
      copiedDate: '',
    };
    this.submittedFormPayload = null;
    this.recurringWarningMessage = '';
    this.addAvailabilityButtonRef = React.createRef()
    this.availabilityFilterRef = React.createRef()
    this.qualificationFilterRef = React.createRef()
    this.saveChanges = this.saveChanges.bind(this)
    this.pagingGroupsPartOfWithAvailability = {}
  }

  receiveAvailabilityTypeModal = (type) => {
    this.setState({
      selectedAvailabilityType: type,
      availabilityTypeModalShowing: false,
    })
  }

  selectedPagingGroupChange = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => ({
      checkedItems: {
        ...prevState.checkedItems,
        [name]: checked,
      },
    }));
  };

  getQualifications = () => {
    this.Requests.callAPI(this.Requests.getQualification).then((data) => {
      if (data?.status === 200 && data.data) {
        this.setState({
          qualifications: data.data
        })
      } else {
        this.setState({
          qualifications: []
        })
      }
    })
  }

  getFavouriteQualifications = () => {
    this.Requests.callAPI(this.Requests.getQualificationFavourites, this.state.pagingGroupAgency).then((data) => {
      if (data?.status === 200 && data.data) {
        let favouritesData = data.data[0]?.qualifications?.map(qual => {
          return (
            { key: qual?.id, value: qual?.name }
          )
        })
        this.setState({
          qualificationFavourites: favouritesData || []
        })
      } else {
        this.setState({
          qualificationFavourites: []
        })
      }
    })
  }

  getJoinedPagingGroups() {
    const agencies = ["AV", "SES", "CFA"]
    const pagingGroups = this.props.userPagingGroupsWithAvailability
    let hasPagingGroups = false
    if (pagingGroups) {
      hasPagingGroups = agencies.reduce((anyGroups, currentGroup) => anyGroups || Boolean(pagingGroups[currentGroup]?.length), false)
    }
    if (hasPagingGroups) {
      agencies.forEach(agency => pagingGroups[agency]?.forEach(group => group.value = { text: group.text, number: group.key, agency }))
      this.pagingGroupsPartOfWithAvailability = pagingGroups
      this.preparePagingGroupData();
    }
    this.hasPagingGroups = hasPagingGroups;
  }

  getPagingGroupsWithAvailability = () => {
    // Fetch all the paging groups the user is a part of and has availability enabled
    let body = {
      availabilityEnabled: true,
    };
    // Update  state to true before the API call
    this.setState({ isLoading: true })
    // Request to get an array of the agencies the user belongs to
    this.Requests.callAPI(this.Requests.postUserPagingGroups, body).then(
      (data) => {
        if (data && data.status && data.status === 200) {
          let pagingGroupsPartOfWithAvailability = {};
          pagingGroupsPartOfWithAvailability.all = [];
          this.props.userAgencies.forEach((item) => {
            pagingGroupsPartOfWithAvailability[item] = [];
          });
          // This sorts all paging groups by their respective agencies into the pagingGroupsPartOf object.
          data.data.forEach((item) => {
            if (
              item.agency &&
              pagingGroupsPartOfWithAvailability[item.agency]
            ) {
              pagingGroupsPartOfWithAvailability[item.agency].push({
                key: item.number,
                text: item.name,
                value: { number: item.number, agency: item.agency },
              });
              // Paging groups with no agency are placed in the 'all' child.
            } else if (!item.agency) {
              pagingGroupsPartOfWithAvailability.all.push({
                key: item.number,
                text: item.name,
                value: { number: item.number, agency: null },
              });
            }
          });
          if (this._isMounted) {
            this.pagingGroupsPartOfWithAvailability = pagingGroupsPartOfWithAvailability
            this.setState(
              {
                isLoading: false
              },
              () => {
                // Now prepare the paging group data
                this.preparePagingGroupData();
              }
            );
          }
        } else {
          let ErrorMessage =
            copy.availability.gettingAvailabilityGroupsErrorMessage;
          this.pagingGroupsPartOfWithAvailability = false
          this.setState(
            {
              errorMessage: ErrorMessage,
              isLoading: false,
            },
            () => {
              setTimeout(
                function () {
                  this.setState({ errorMessage: null });
                }.bind(this),
                5000
              );
            }
          )
        }
      }
    );
  };

  componentDidMount() {
    this._isMounted = true;
    this.fetchSortByOptions();
    this.fetchViewByRange();
    this.addNotchSafePadding();
    window.addEventListener("orientationchange", this.handleWindowSizeChange);
    window.addEventListener("resize", this.handleWindowSizeChange);
    window.sessionStorage.setItem("redirectHomeFromEvent", "");
    window.sessionStorage.setItem("myAvailabilityChanges", false);
    if (this.props.history.location.pathname === '/myavailability/Dashboard') {
      this.getPagingGroupsWithAvailability()
    } else {
      this.getJoinedPagingGroups();
    }
    this.getQualifications();

    if (this.props.match) {
      if (this.props.match.params) {
        this.updateTab(this.props.match.params.tab);
      }
    }
    // This finds the current time to set the default load
    let time = new Date();

    // round time to the current half-hr block
    if (time.getMinutes() >= 0 && time.getMinutes() < 30) {
      time.setMinutes(0);
    } else {
      time.setMinutes(30);
    }

    time = format(time, "HH:mm");

    this.setState({
      details: {
        start: time,
      },
    });
  }

  // This function checks which tab to show
  componentDidUpdate(prevProps, prevState) {
    if (this.props.match) {
      if (this.props.match.params) {
        if (
          typeof this.props.match.params.tab !== "undefined" &&
          typeof prevProps.match.params.tab !== "undefined" &&
          this.props.match.params.tab !== prevProps.match.params.tab
        ) {
          this.updateTab(this.props.match.params.tab);
        }
      }
    }
    document.querySelectorAll(`.ui.dropdown`).forEach((dropdown) => {
      dropdown.setAttribute("role", "combobox");
    });
    if (this.state.pagingGroupAgency !== prevState.pagingGroupAgency) {
      // check if the selected sort by type is in the allowed types for the new agency
      const allowedTypes = copy.myAvailabilityScreen.agencyAvailabilityTypes[this.state.pagingGroupAgency]
      const defaultType = copy.myAvailabilityScreen.agencyAvailabilityTypes.default
      if (!allowedTypes.includes(this.state.sortByType)) {
        this.applySortByOptions(this.state.sortByOption, defaultType, this.state.sortByFirstName, this.state.sortByAtoZ)
      }
    }
  }
  /**
   * This function will be called whenever a new tab is clicked (which leads to the URL changing)
   * It will update the current tab
   */
  updateTab(taburl) {

    if (taburl === copy.taburls.myAvailability) {
      this.setState({
        currentTab: copy.myAvailabilityScreen.myAvailability.title,
        currentTabNumber: copy.tabIndices.myAvailability,
        onQualificationsTab: false,
      });
    } else if (taburl === copy.taburls.overview) {
      this.setState({
        currentTab: copy.availability.overview,
        currentTabNumber: copy.tabIndices.overview,
        onQualificationsTab: false,
      });
    } else if (taburl === copy.taburls.myAvailabilityDashboard) {
      this.setState({
        currentTab: copy.myAvailabilityScreen.myAvailabilityDashboard,
        currentTabNumber: copy.tabIndices.myAvailabilityDashboard,
        onQualificationsTab: false,
      });
    } else {
      this.props.history.push({
        pathname: "/*",
        state: { errorMessage: copy.error_page.errorMessage },
      });
    }
  }

  /**
   * This function is used to prepare the data for the paging groups filter
   */
  preparePagingGroupData = () => {
    // Change in R4 - all CFA and SES users can use dashboard
    let adminAgencies = ["CFA", "SES", "AV"];

    // Getting all paging groups the user has access to
    let pagingGroups = [];
    let pagingGroupsNoAV = [];
    adminAgencies.forEach((agency) => {
      // If the user has permission to view paging groups of that agency, add the paging groups to the filter
      if (this.pagingGroupsPartOfWithAvailability) {
        if (
          this.pagingGroupsPartOfWithAvailability[agency] &&
          this.pagingGroupsPartOfWithAvailability[agency].length > 0
        ) {
          pagingGroups = pagingGroups.concat(
            this.pagingGroupsPartOfWithAvailability[agency]
          );
          if (agency !== "AV") {
            pagingGroupsNoAV = pagingGroupsNoAV.concat(
              this.pagingGroupsPartOfWithAvailability[agency]
            );
          }
        }
      }
    });
    if (this.props.pagingGroupsOwned) {
      Object.entries(this.props.pagingGroupsOwned).forEach((entry) => {
        // If user is not admin of the agency but owns paging groups of that agency, add the paging groups they own to the filter
        // Check to see if the paging group the user is an owner has availabilityenabled
        if (adminAgencies.indexOf(entry[0]) === -1 && entry[1].length > 0) {
          Object.entries(entry[1]).forEach((group) => {
            if (group[1] && group[1].availabilityenabled === "true") {
              // Adding paging group to filter
              pagingGroups = pagingGroups.concat(group[1]);

              if (entry[0] !== "AV") {
                pagingGroupsNoAV = pagingGroupsNoAV.concat(group[1]);
              }
            }
          });
        }
      });

      // For CFA - default to 'CFA ALL'
      // For AV - default to alphabetically first group
      // For SES - default to first group that a user has access to that contains the term "Unit"

      const defaultAgency = pagingGroups[0] ? pagingGroups[0].value.agency : null;
      let defaultPagingGroup = pagingGroups[0] ? pagingGroups[0].value : null;
      let pagingGroup = pagingGroups[0] ? pagingGroups[0].value.number : null;
      let defaultPagingGroupName = pagingGroups[0] ? pagingGroups[0].text : null;
      if (defaultAgency) {
        let defaultGroup
        switch (defaultAgency) {
          case "SES":
            defaultGroup = pagingGroups
              .filter((group) => group.value.agency === "SES")
              .find((group) => group.text.toLowerCase().includes("unit"))
            break;
          case "CFA":
            defaultGroup = pagingGroups
              .filter((group) => group.value.agency === "CFA")
              .find((group) => group.text.toLowerCase().includes("brigade"))
            break;
          case "AV":
            defaultGroup = pagingGroups
              .filter((group) => group.value.agency == "AV")
              .toSorted((a, b) => {
                const textA = a.text.toUpperCase()
                const textB = b.text.toUpperCase()
                if (textA < textB) {
                  return -1
                }
                if (textB > textA) {
                  return 1
                }
                return 0
              })[0]
            break;
        }
        defaultPagingGroup = defaultGroup?.value || defaultPagingGroup
        pagingGroup = defaultGroup?.value.number || pagingGroup
        defaultPagingGroupName = defaultGroup?.text || defaultPagingGroupName
      }


      if (defaultPagingGroup) {
        defaultPagingGroup["text"] =
          defaultPagingGroupName && defaultPagingGroupName;
      }
      let pagingGroupAgency = null;
      const pagingGroupID = parseInt(
        window.localStorage.getItem("PagingGroupID")
      );
      const pagingGroupAgencyID =
        window.localStorage.getItem("PagingGroupAgency");
      const pagingGroupName =
        window.localStorage.getItem("PagingGroupName");
      if (pagingGroupID && pagingGroupAgencyID && pagingGroupName) {
        const matchingGroup = pagingGroups.find(
          (group) => group.key === pagingGroupID
        );
        if (matchingGroup) {
          defaultPagingGroup = {
            agency: pagingGroupAgencyID,
            number: pagingGroupID,
            text: pagingGroupName,
          };
          pagingGroup = pagingGroupID;
          pagingGroupAgency = pagingGroupAgencyID;
        }
        else {
          window.localStorage.setItem("PagingGroupID", defaultPagingGroup.number);
          window.localStorage.setItem("PagingGroupAgency", defaultPagingGroup.agency);
          window.localStorage.setItem("PagingGroupName", defaultPagingGroup.text);
        }
      }
      else {
        window.localStorage.setItem("PagingGroupID", defaultPagingGroup.number);
        window.localStorage.setItem("PagingGroupAgency", defaultPagingGroup.agency);
        window.localStorage.setItem("PagingGroupName", defaultPagingGroup.text);
      }
      // This puts the results in the paging group dropdown
      this.setState(
        {
          userPagingGroupsOption: pagingGroups,
          userPagingGroupsOptionNoAV: pagingGroupsNoAV,
          defaultPagingGroup: defaultPagingGroup,
          pagingGroupName: defaultPagingGroup.text,
          pagingGroupAgency: defaultPagingGroup.agency || this.state.pagingGroupAgency,
        },
        () => {
          // this selects a paging group from the dropdown and activates the calendar
          this.getFavouriteQualifications();
          this.setState(
            {
              pagingGroup: pagingGroup,
            },
            () => {
              // Only call these functions if the user has paging groups
              if (this.state.pagingGroup) {
                // This loads the threshold criterias set in the admin paging group details section
                this.getThresholdRequirements();

                // This acts as a calendar click event, loading today's timeslots
                let date = new Date();
                const calendarDate =
                  window.localStorage.getItem("dashboardDate");
                if (calendarDate) {
                  date = new Date(calendarDate);
                }
                window.localStorage.removeItem("dashboardDate");

                // this checks if the user is viewing this on a mobile
                const isMobile = this.state.width <= 1023;
                if (!isMobile) {
                  // If this is NOT on a mobile, then the details of the current time need to be loaded as well
                  this.setState({ ready: true }, () => {
                    this.dayCallbackFunction(this.state.details);
                  });
                }
              }
            }
          );
        }
      );
    }
  };

  // This function loads the threshold criterias set in the admin paging group details section
  // It actually gets all the information on the selected paging group, but we only need the threshold criterias
  // And there is no other APIs with that information

  getThresholdRequirements = () => {
    // Update  state to true before the API call
    this.setState({ isLoading: true })
    this.Requests.callAPI(
      this.Requests.getPagingGroup,
      this.state.pagingGroup
    ).then((data) => {
      if (data && data.status && data.status === 200) {
        if (data.data.settings) {
          if (data.data.settings.thresholdType) {
            let type = data.data.settings.thresholdType;
            // This checks to see if the threshold is based off People count
            if (data.data.settings.qualificationPaging.length !== 0) {
              this.setState({
                qualList: data.data.settings.qualificationPaging,
                thresholdNotSet: false,
              });
            } else {
              this.setState({
                qualList: null,
                thresholdNotSet: true,
              });
            }
            if (type === "ByPeople") {
              // The default is by people
              // No need to change the the state for thresholdType
              if (data.data.settings.thresholdByPeopleCount) {
                this.setState({
                  thresholdByPeopleCount:
                    data.data.settings.thresholdByPeopleCount,
                  thresholdType: data.data.settings.thresholdType,
                  thresholdNotSet: false,
                });
              }
            } else {
              // If this is not set to people, it's set to qualification
              // Change the type to qualification
              this.setState({
                thresholdType: data.data.settings.thresholdType,
              });
            }
            this.setState({ failedAPI: false });
          }
        }
        this.setState({ isLoading: false })
      } else {
        let ErrorMessage =
          copy.availability.getPagingGroupThresholdAPIErrorMessage +
          ` (Error #${copy.errorCodes.getPagingGroupThresholdAPIErrorMessage})`;
        let ErrorCode = copy.errorCodes.getPagingGroupThresholdAPIErrorMessage;
        this.setState(
          {
            errorMessage: ErrorMessage,
            failedAPI: true,
            errorCode: ErrorCode,
            isLoading: false
          },
          () => {
            setTimeout(
              function () {
                this.setState({ errorMessage: null });
              }.bind(this),
              5000
            );
          }
        )
      }
    });
  };

  updatePagingGroup = () => {
    const available = copy.myAvailabilityScreen.agencyAvailabilityTypes.default
    const prevPagingGroup = this.state.pagingGroupAgency
    this.setState({
      selectedAvailabilityType: (prevPagingGroup !== this.state.pagingGroupPayload?.agency) ? available : this.state.selectedAvailabilityType,
      pagingGroup: this.state.pagingGroupPayload?.number,
      pagingGroupName: this.state.pagingGroupPayload.text,
      pagingGroupAgency: this.state.pagingGroupPayload?.agency,
      defaultPagingGroup: this.state.pagingGroupPayload,
      selectedQualifications: this.state.pagingGroupAgency !== this.state.pagingGroupPayload?.agency ? [] : this.state.selectedQualifications,
      qualificationsToggle: this.state.pagingGroupPayload?.agency === "AV" ? false : this.state.qualificationsToggle
    }, () => {
      this.getThresholdRequirements()
      if (prevPagingGroup !== this.state.pagingGroupAgency) {
        this.getFavouriteQualifications();
      }
    })
    window.localStorage.setItem("PagingGroupID", this.state.pagingGroupPayload?.number);
    window.localStorage.setItem("PagingGroupAgency", this.state.pagingGroupPayload?.agency);
    window.localStorage.setItem("PagingGroupName", this.state.pagingGroupPayload?.text);
  }

  selectPagingGroup = (value) => {
    // show prompt for carrying uncommitted changes over paging groups
    this.setState({
      pagingGroupPayload: value,
    }, () => {
      if (this.state.uncommittedChanges.length > 0) {
        this.setState({
          uncommittedChangesWarningPromptShowing: true,
        })
      } else {
        this.updatePagingGroup()
      }
    })
  };

  dayCallbackFunction = (childData) => {
    this.setState({
      results: null,
      resultsLoading: true,
      details: { start: childData.start },
    });

    let details = {
      date: this.state.callbackDate,
      timeStart: childData.start,
    };

    // Update  state to true before the API call
    this.setState({ isLoading: true })
  };

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.handleWindowSizeChange);
    window.removeEventListener(
      "orientationchange",
      this.handleWindowSizeChange
    );
  }

  setViewByRange = (range) => {
    window.localStorage.setItem("viewByRange", range)
    this.setState({
      viewByModalShowing: false,
      viewByRange: range,
    })
  }

  fetchViewByRange = () => {
    const viewByRange = window.localStorage.getItem("viewByRange")
    // check if window size supports range, else default to weekly
    if (viewByRange) {
      if (window.innerWidth <= 768 && viewByRange === 'Bi-weekly') {
        this.setViewByRange('Weekly')
      } else {
        this.setState({viewByRange})
      }
    }
  }

  applySortByOptions = (selection, type, firstName, AtoZ) => {
    const sortByOptions = JSON.stringify({ selection, type, firstName, AtoZ });
    window.localStorage.setItem("sortByOptions", sortByOptions);
    this.setState({
      sortByModalShowing: false,
      sortByOption: selection,
      sortByType: type,
      sortByFirstName: firstName,
      sortByAtoZ: AtoZ,
    });
  }

  fetchSortByOptions = () => {
    const sortByOptionsString = window.localStorage.getItem("sortByOptions");
    if (sortByOptionsString) {
      let sortByOptions = JSON.parse(sortByOptionsString);
      this.setState({
        sortByOption: sortByOptions.selection,
        sortByType: sortByOptions.type,
        sortByFirstName: sortByOptions.firstName,
        sortByAtoZ: sortByOptions.AtoZ,
      });
    }
  }
  addNotchSafePadding = () => {
    const schedulerRedo = document.getElementById('dhx_redo_button');
    const schedulerUndo = document.getElementById('dhx_undo_button');
    const membersHeader = document.getElementById('membersAvailabilityHeader');
    if((schedulerRedo || schedulerUndo || membersHeader) && window.cordova && window.cordova.platformId === 'ios') {
      // Reset padding 
      const phoneNotchSafeArea = schedulerRedo ? schedulerRedo.style : membersHeader.style;
      const phoneNotchSafeAreaUndo = schedulerUndo ? schedulerUndo.style : {};
      if(phoneNotchSafeAreaUndo){
        phoneNotchSafeAreaUndo.paddingRight = "0";
      }
      if(phoneNotchSafeArea){
        phoneNotchSafeArea.paddingRight = "0";
        phoneNotchSafeArea.paddingLeft = "0";
      }
      if(window.screen.orientation.type === 'landscape-primary') {
        if (schedulerUndo){
          if (window.device.model !== undefined) {
            const modelName = window.device.model.toLowerCase();
            if (modelName.includes('iphone') && this.state.viewByRange === 'Bi-weekly') {
              phoneNotchSafeArea.paddingLeft = "0";
            } else {
              phoneNotchSafeArea.paddingLeft = "calc(env(safe-area-inset-left) - 1.8rem)";
            }
          }
        }
        if (membersHeader){
          phoneNotchSafeArea.paddingLeft = "calc(env(safe-area-inset-left) - 1rem)";
        }
      }
      if(window.screen.orientation.type === 'landscape-secondary') {
        if (schedulerRedo){
          if (window.device.model !== undefined) {
            const modelName = window.device.model.toLowerCase();
            const reduceMarginNextbutton = document.getElementById('next-button');
            const redoIcon = schedulerRedo.querySelector('.icon');
            //dealing the overlap issue of iphone notch when it's bi-weekly in landscape
            if (modelName.includes('iphone') && this.state.viewByRange === 'Bi-weekly') {
              phoneNotchSafeArea.paddingRight = "calc(env(safe-area-inset-right) - 2.2rem)";
              reduceMarginNextbutton.style.paddingLeft = "0";
              if (redoIcon) {
                redoIcon.style.marginRight = ".1rem";
              }
            } else {
              phoneNotchSafeArea.paddingRight = "calc(env(safe-area-inset-right) - 1.8rem)";
              reduceMarginNextbutton.style.paddingLeft = "1rem";
              if (redoIcon) {
                redoIcon.style.marginRight = ".625rem";
              }
            }
          }
        }
        if (membersHeader){
          phoneNotchSafeArea.paddingRight = "calc(env(safe-area-inset-right) - 10px)";
        }
      }
    }
  }
  handleWindowSizeChange = () => {
    this.addNotchSafePadding();
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
    this.setState({ isMobileLandscapeMode: isLandscape });
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    if (this.props.match) {
      if (this.props.match.params) {
        if (typeof this.props.match.params.tab !== "undefined") {
          this.updateTab(this.props.match.params.tab);
        }
      }
    }
  };

  handleTabClick = () => {
    if (this.state.width <= 1023 && this.state.defaultPagingGroup) {

    }
  };
  generateRepeatSummaryMessage = (payload) => {
    const {
      availabilityTypes,
      seriesType,
      date,
      dateTo,
      timeFrom,
      timeTo,
      pagingGroups,
      repeatCount,
      dateOfMonth,
      daysOfWeek,
    } = payload;
    const dateFormat = "dd/MM/yy";
    const today = format(new Date(), dateFormat);
    const availabilityTypeString = availabilityTypes.join(' and ');
    const parsedStartDate = format(parseISO(date), 'dd MMMM yyyy');
    const parsedEndDate = dateTo ? format(parseISO(dateTo), 'dd MMMM yyyy') : format(parseISO(today), 'dd MMMM yyyy');

    let message = null;
    // Daily recurrence
    if (seriesType === "Daily") {
      message = (
        <p>
          {availabilityTypeString} for <strong>{repeatCount} day(s) </strong>
          starting <strong>{parsedStartDate} </strong>
          until{' '}
          <strong>
            {parsedEndDate}
          </strong>
          {' '}from <strong>{timeFrom}</strong> to <strong>{timeTo}</strong>.
        </p>
      );
    }
    // Weekly recurrence
    if (seriesType === "Weekly" && daysOfWeek.length > 0) {
      const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      message = (
        <p>
          {availabilityTypeString} for <strong>{repeatCount} week(s) </strong>
          starting on every {new Intl.ListFormat('en', { style: 'long', type: 'conjunction' }).format(
            daysOfWeek
              .sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)) // Sort based on predefined order
          )} from <strong>{parsedStartDate} </strong>
          until{' '}
          <strong>
            {parsedEndDate}
          </strong>
          , from <strong>{timeFrom}</strong> to <strong>{timeTo}</strong>.
        </p>
      );
    }
    // Monthly recurrence
    if (seriesType === "Monthly") {
      message = (
        <p>
          {availabilityTypeString} for <strong>{repeatCount} month(s) </strong>
          starting on the {getOrdinalSuffix(dateOfMonth)} of every month from <strong>{parsedStartDate} </strong>
          until{' '}
          <strong>
            {parsedEndDate}
          </strong>
          , from <strong>{timeFrom}</strong> to <strong>{timeTo}</strong>.
        </p>
      );
    }
    const agencyGroups = this.pagingGroupsPartOfWithAvailability[this.state.pagingGroupAgency] || [];
    const pagingGroupNames =
      pagingGroups.map((id) => {
        const group = agencyGroups.find((group) => group.key === Number(id));
        return group?.text;
      })
        .filter(Boolean)
        .join(", ");
    const pagingGroupMessage = (<p>For {this.state.pagingGroupAgency} - {pagingGroupNames}</p>);
    const noteMessage = (<p><em>Note that this will override any existing availability.</em></p>);
    const recurringWarningMessage = (<>{message}{pagingGroupMessage}{noteMessage}</>);
    return recurringWarningMessage;
  };
  showShortRecurringOverideWarnings = (payload) => {
    const isRcurring = payload.seriesType ? true : false;
    this.setState({ isRcurring });
    if (isRcurring) {
      this.recurringWarningMessage = this.generateRepeatSummaryMessage(payload);
    }
    this.submittedFormPayload = payload;
    this.setState({ isShowFormSOverride: true });
  }
  onFormSubmit = () => {
    const payload = this.submittedFormPayload;
    const { isRcurring } = this.state;
    // Dual availability submitted using the short form should result in two separate availabilities: one of each type
    const availabilityTypes = payload.availabilityTypes
    // Tracking uncommitted changes only for the currently selected paging group
    // For all other paging groups, send to BE immediately with isOverrideDay=false
    const otherPagingGroups = payload.pagingGroups.filter(group => group !== this.state.pagingGroup.toString())
    if (otherPagingGroups.length > 0) {
      const availability = {}
      const availabilities = []
      const isUnavailable = payload.availabilityTypes.includes('Unavailable')
      availability.timeStart = payload.timeFrom
      availability.timeEnd = payload.timeTo
      availability.availabilityTypes = isUnavailable ? null : payload.availabilityTypes
      availability.isUnavailable = isUnavailable;
      availabilities.push(availability);
      let otherPagingGroupsPayload = [];
      if (isRcurring) {
        otherPagingGroupsPayload = [{
          dateFrom: payload.date,
          dateTo: payload.dateTo,
          timeStart: payload.timeFrom,
          timeEnd: payload.timeTo,
          dateOfMonth: payload.dateOfMonth,
          availabilityTypes: payload.availabilityTypes,
          isUnavailable: payload.availabilityTypes.includes('Unavailable'),
          pagingNumber: otherPagingGroups,
          seriesType: payload.seriesType,
          daysOfWeek: payload.daysOfWeek,
        }];
      } else {
        otherPagingGroupsPayload = {
          date: payload.date,
          pagingNumber: otherPagingGroups,
          availabilities: availabilities
        };
      }
      this.submitForm(otherPagingGroupsPayload, isRcurring);
    }
    let selectedGroups = {}
    payload.pagingGroups?.forEach((group) => {
      selectedGroups[group] = true;
    })
    if (payload.pagingGroups.includes(this.state.pagingGroup.toString())) {
      this.setState({
        payload,
      })
    }
    this.setState({
      selectedGroups,
      selectedAgency: payload.userAgency
    })
  }

  submitForm = (payload, isRecurrent) => {
    const API_ENDPOINT = isRecurrent ? this.Requests.addRecurrntAvailability : this.Requests.addAvailabilityShortForm;
    this.Requests.callAPI(API_ENDPOINT, payload, false).then((data) => {
      if (data?.status === 200) {
        this.toastie("Data has been updated!", "success");
      } else if (data.data !== undefined) {
        this.toastie(
          `Oops! Something went wrong! (${data.data.HTTPStatusCode} - ${data.data.SASMessageClient})`,
          "error"
        )
      } else {
        this.toastie(
          `Oops! Something went wrong! (${data.status} - ${data.statusText})`,
          "error"
        )
      }
    })
  }

  updateChanges = (payload) => {
    this.setState({
      uncommittedChanges: payload
    }, () => {
      window.sessionStorage.setItem("myAvailabilityChanges", this.state.uncommittedChanges.length > 0 ? true : false);
    })
  }

  /**
* Displays a toaster on the lower left of the screen
* @param {String} message Message to be displayed in the toaster
* @param {String} type Type of toaster (info, error, warning, success)
*/
  toastie = (message = "Hello world!", type = "info") => {
    mdtoast(message, {
      duration: 5000,
      type: type,
      interaction: false,
    });
  };

  constructEventPayload = (event) => {
    const availability = {}
    const isUnavailable = event.eventType.includes('Unavailable')
    availability.timeStart = format(event.start_date, "HH:mm")
    availability.timeEnd = format(event.end_date, "HH:mm")
    availability.availabilityTypes = !isUnavailable ? event.availabilityTypes : null
    availability.isUnavailable = isUnavailable
    return availability
  }

  constructDayPayload = (day) => {
    const dayPayload = {
      date: format(day.dayOfChange, "yyyy-MM-dd"),
      pagingNumber: this.state.pagingGroup,
    }
    const availabilities = []
    day.daySnapshot.forEach((event) => {
      let eventPayload = this.constructEventPayload(event)
      availabilities.push(eventPayload)
    })
    if (availabilities.length > 0) {
      dayPayload.availabilities = availabilities;
    }
    return dayPayload
  }

  saveChanges = () => {
    const API_ENDPOINT = this.Requests.addAvailabilityNew;
    // for each week with uncommitted changes, get the days with uncommitted changes
    const payload = this.state.uncommittedChanges;
    // pass to API
    this.Requests.callAPI(API_ENDPOINT, payload).then((data) => {
      if (data?.status === 200) {
        this.toastie("Data has been updated!", "success");
        // clear the uncommitted changes
        this.setState({
          clearUncommittedChanges: true,
          uncommittedChanges: []
        },
        () => {
          window.sessionStorage.setItem("myAvailabilityChanges", false);
        });

      } else if (data.data !== undefined) {
        this.toastie(
          `Oops! Something went wrong! (${data.data.HTTPStatusCode} - ${data.data.SASMessageClient})`,
          "error"
        );
      } else {
        this.toastie(
          `Oops! Something went wrong! (${data.status} - ${data.statusText})`,
          "error"
        );
      }
    })
  }

  /**
   * Handle refresh of page when API call fails for Threshold tab in Mobile
   */
  handleThresholdViewRefresh = () => {
    this.getThresholdRequirements();
  };

  uncommittedChangesCleared = () => {
    this.setState({
      clearUncommittedChanges: false
    })
  }

  handleCopyClick = () => {
    const copiedAvailability = {
      AvailabilityTemplateItems: copyWeek(),
      Agency: this.state.pagingGroupAgency
    }
    const minDate = scheduler.getState().min_date;
    const copiedDate = minDate && !isNaN(new Date(minDate).getTime())
    ? new Intl.DateTimeFormat("en-AU").format(new Date(minDate))
    : '';
    this.setState({ clipboardFilled: true , copiedDate:  copiedDate}, () => {
      window.sessionStorage.setItem("copiedAvailability", JSON.stringify(copiedAvailability))
    })
  }

  handlePasteClick = () => {
    const copiedAvailability = JSON.parse(window.sessionStorage.getItem("copiedAvailability"));
    const copiedAgency = copiedAvailability.Agency
    const availabilityToApply = copiedAvailability.AvailabilityTemplateItems
    const viewStart = scheduler.getState().min_date
    const viewEnd = scheduler.getState().max_date
    const eventsInView = scheduler.getEvents(viewStart, viewEnd)
    // agency compatibility check
    // if CFA: CFA or AV allowed
    // if AV: CFA or AV allowed
    // if SES: SES allowed
    let incompatibleAgency = false;
    switch (this.state.pagingGroupAgency) {
      case "SES":
        if (copiedAgency !== "SES") {
          this.setState({ incompatibleAgencyPromptShowing: true })
          incompatibleAgency = true;
        }
        break;
      default:
        if (copiedAgency === "SES") {
          this.setState({ incompatibleAgencyPromptShowing: true })
          incompatibleAgency = true;
        }
        break;
    }
    // overwrite warning
    if (!incompatibleAgency) {
      if (eventsInView.length > 0) {
        this.setState({ overwritePromptShowing: true })
      }
      else {
        this.setState({ templateToApply: availabilityToApply })
      }
    }
  }

  renderMyAvailabilityViewMobile = (currentWidth, currentHeight) => {
    const copiedAvailability = JSON.parse(window.sessionStorage.getItem("copiedAvailability"));
    const smallScreen = currentWidth <= 768 && (currentHeight / currentWidth > 1);
    const selectedType = this.state.selectedAvailabilityType;
    const pagingGroups = this.pagingGroupsPartOfWithAvailability;
    const userAgencies = this.props.userAgencies
      .filter((agency) => (agency !== 'DYNAMIC'))
    const defaultAgency = this.state.defaultPagingGroup ? this.state.defaultPagingGroup.agency : userAgencies[0];
    const viewByOptions = smallScreen ? ["3 day", "Weekly"] : ["3 day", "Weekly", "Bi-weekly"]
    const addAvailabilityButton = <Button
      ref={this.addAvailabilityButtonRef}
      label={copy.myAvailabilityScreen.myAvailability.addAvailability}
      content={this.state.selectedAvailabilityType ? this.state.selectedAvailabilityType : "Add Availability"}
      variant="btn_addAvailabilityButs"
      styles={copy.myAvailabilityScreen.addAvailabilityButtonStyles[this.state.selectedAvailabilityType]}
      icon={(selectedType === 'Unavailable' || selectedType === 'Emergency' ? "icon_add_availability_white" : "icon_add_availability_grey")}
      buttonClick={() => {
        this.setState({ availabilityTypeModalShowing: true });
      }}
    />
    const saveButton = <Button
      label={copy.myAvailabilityScreen.myAvailability.save}
      content={copy.myAvailabilityScreen.myAvailability.save}
      variant="btn_saveButton"
      buttonClick={this.saveChanges}
      send_disable={this.state.uncommittedChanges.length === 0}
    />
    const ellipsesIcon = <Icon
      icon="icon_ellipses"
    />
    const pasteIcon = <Icon
      icon="icon_paste"
    />
    const copyIcon = <Icon
      icon="icon_copy"
    />
    const chevronIcon = <Icon
      icon="icon_chevron_right"
    />
    const fullOptions = this.state.width > 950;
    const copyLabel = "Copy current week";
    const pasteLabel = this.state.clipboardFilled && this.state.copiedDate ? "Paste week "+this.state.copiedDate + ' in current view' : "Paste"
    const ellipsesDropdownButton = <Button
      disabled={true}
      variant="btn_myAvailabilityButs"
      icon="icon_ellipsesDots"
      label="More options"
      content="More options"
    />
    const ellipsesDropdown =
      <Dropdown
        aria-label="Listbox menu"
        direction='left'
        trigger={fullOptions && ellipsesDropdownButton}
        icon={!fullOptions && ellipsesIcon}
        className={styles.dropdown + " ellipsesDropdownClass"}>
        <DropdownMenu className={styles.dropdownMenu + " ellipsesMenu mySchedulerDropdown"}>
          <DropdownHeader content="Options" className={styles.dropdownHeader} />
          <DropdownDivider />
          <DropdownItem
            onClick={() => this.setState(
              { viewByModalShowing: true }
            )}
            className={styles.dropdownItem}
          >
            View by
            {chevronIcon}
          </DropdownItem>
          <DropdownItem
            onClick={() => this.setState(
              { availabilityFormShowing: true }
            )}
            className={styles.dropdownItem}

          >
            Recurring availability
            {chevronIcon}
          </DropdownItem>
          <DropdownItem
            onClick={() => this.setState(
              { availabililtyTemplateModalShowing: true }
            )}
            className={styles.dropdownItem}
          >Templates
          {chevronIcon}
          </DropdownItem>
          <DropdownItem
            onClick={this.handleCopyClick}
          >{pasteIcon}{copyLabel}</DropdownItem>
          <DropdownItem
            onClick={this.handlePasteClick}
            disabled={!(this.state.clipboardFilled && this.state.copiedDate)}
          >{copyIcon}{pasteLabel}</DropdownItem>
        </DropdownMenu>
      </Dropdown>

    const setPagingGroupButton = <Button
      disabled={true}
      id="pagingGroupButton"
      styles={`${styles.setPagingGroupButtonClass}`}
      label={
        this.state.defaultPagingGroup
          ? this.state.defaultPagingGroup.agency +
          " - " +
          this.state.defaultPagingGroup.text
          : copy.myAvailabilityScreen.myAvailability.setPagingGroup
      }
      content={
        this.state.defaultPagingGroup ? (
          <div className={styles.setPagingGroupButtonContent}>
            {this.state.defaultPagingGroup.agency +
              " - " +
              this.state.defaultPagingGroup.text}
          </div>
        ) : (
          copy.myAvailabilityScreen.myAvailability.setPagingGroup
        )
      }
      variant="btn_myAvailabilityButs"
      icon="icon_arrowDownSmall"
    />
    // set paging group dropdown component
    const setPagingGroupDropDown = (
      <SetPagingGroupDropdown
        userAgencies={userAgencies}
        pagingGroups={pagingGroups}
        setPagingGroupButton={setPagingGroupButton}
        defaultPagingGroup={this.state.defaultPagingGroup}
        defaultAgency={defaultAgency}
        smallScreen={smallScreen}
        selectPagingGroup={this.selectPagingGroup}
      />
    );
    const overwritePromptButtons = [
      <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.buttons.back}
        buttonClick={() => this.setState({ overwritePromptShowing: false })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.buttons.back}
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>,
      <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.buttons.confirm}
        buttonClick={() => this.setState({
          overwritePromptShowing: false,
          templateToApply: copiedAvailability.AvailabilityTemplateItems
        })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.buttons.confirm}
        variant="btn_secondary"
        styles="neutralGrey"
      ></Button>
    ]
    const incompatibleAgencyPromptButtons = [
      <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.incompatibleAgency.buttons.back}
        buttonClick={() => this.setState({ incompatibleAgencyPromptShowing: false })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.incompatibleAgency.buttons.back}
        variant="btn_secondary"
        styles="neutralGrey"
      />
    ]
    const uncommittedChangesWarningPromptButtons = [
      <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.back}
        buttonClick={() => this.setState({ uncommittedChangesWarningPromptShowing: false })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.back}
        variant="btn_secondary"
        styles="neutralGrey"
      />, <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.discard}
        buttonClick={() => this.setState({
          uncommittedChangesWarningPromptShowing: false,
          clearUncommittedChanges: true,
          uncommittedChanges: [],
        }, () => {
          this.updatePagingGroup()
        })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.discard}
        variant="btn_secondary"
        styles="neutralGrey"
      />, <Button
        label={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.save}
        buttonClick={() => this.setState({ uncommittedChangesWarningPromptShowing: false }, () => {
          this.saveChanges();
          this.updatePagingGroup();
        })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.buttons.save}
        variant="btn_secondary"
        styles="neutralGrey"
      />
    ]
    const shortRecurrentWarningPromptButtons = [
      <Button
        key="shortRecurrentBack"
        label={copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.buttons.back}
        buttonClick={() => this.setState({ isShowFormSOverride: false })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.buttons.back}
        variant="btn_secondary"
        styles="neutralGrey"
      />, <Button
        key="shortRecurrentConfirm"
        label={copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.buttons.confirm}
        buttonClick={() => this.setState({
          isShowFormSOverride: false,
        }, () => {
          this.onFormSubmit();
        })}
        content={copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.buttons.confirm}
        variant="btn_secondary"
        styles="neutralGrey"
      />
    ];
    return (
      <div
        content={copy.myAvailabilityScreen.myAvailability.title}
        taburl={copy.taburls.myAvailability}
        superscript={copy.myAvailabilityScreen.myAvailability.superscript}
        style='tab-item-availability'
      >
        {this.hasPagingGroups ? (
          <>
            {this.state.isShowFormSOverride && <Prompt
              isVisible={this.state.isShowFormSOverride}
              titleText={this.state.isRcurring ? copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.recurrentTitle : copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.shortTitle}
              subtitleText={this.state.isRcurring ? this.recurringWarningMessage : <em>{copy.myAvailabilityScreen.myAvailability.prompts.shortRecurrentWarning.subtitle}</em>}
              buttons={shortRecurrentWarningPromptButtons}
              onClose={() => this.setState({ isShowFormSOverride: false })}
            />}
            {this.state.uncommittedChangesWarningPromptShowing && <Prompt
              isVisible={this.state.uncommittedChangesWarningPromptShowing}
              titleText={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.title}
              subtitleText={copy.myAvailabilityScreen.myAvailability.prompts.uncommittedChangesWarning.subtitle}
              buttons={uncommittedChangesWarningPromptButtons}
              onClose={() => this.setState({ uncommittedChangesWarningPromptShowing: false })}
            />}
            {this.state.overwritePromptShowing && <Prompt
              isVisible={this.state.overwritePromptShowing}
              titleText={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.title}
              subtitleText={copy.myAvailabilityScreen.myAvailability.prompts.templateOverwrite.subtitle}
              buttons={overwritePromptButtons}
              onClose={() => this.setState({ overwritePromptShowing: false })}
            />}
            {this.state.incompatibleAgencyPromptShowing && <Prompt
              isVisible={this.state.incompatibleAgencyPromptShowing}
              titleText={copy.myAvailabilityScreen.myAvailability.prompts.incompatibleAgency.title}
              subtitleText={copy.myAvailabilityScreen.myAvailability.prompts.incompatibleAgency.subtitle}
              buttons={incompatibleAgencyPromptButtons}
              onClose={() => this.setState({ incompatibleAgencyPromptShowing: false })}
            />}
            {this.state.availabilityTypeModalShowing && <AvailabilityTypeModal
              isVisible={this.state.availabilityTypeModalShowing}
              onClose={() => this.setState({ availabilityTypeModalShowing: false },
                () => {
                  if (scheduler.getEvent(this.state.eventId)) {
                    scheduler.deleteEvent(this.state.eventId)
                  }
                })}
              title={copy.myAvailabilityScreen.myAvailability.availabilityTypeModal.title}
              description={copy.myAvailabilityScreen.myAvailability.availabilityTypeModal.description}
              userAgency={defaultAgency}
              submitForm={this.receiveAvailabilityTypeModal}
              position={this.addAvailabilityButtonRef.current.getBoundingClientRect()}
              selectedAvailabilityType={this.state.selectedAvailabilityType}
              closeDropdown={() => this.setState({ availabilityTypeModalShowing: false })}
              singleSelect={true}
            />}
            {this.state.availabilityFormShowing && <AddAvailabilityForm
              isVisible={this.state.availabilityFormShowing}
              onClose={() => this.setState({ availabilityFormShowing: false })}
              onApplyClick={this.showShortRecurringOverideWarnings}
              pagingGroups={pagingGroups}
              userAgencies={userAgencies}
              defaultAgency={defaultAgency}
              currentWidth={currentWidth}
              currentHeight={currentHeight}
              selectedGroups={this.state.selectedGroups}
              selectedAgency={this.state.selectedAgency}
            />}
            {this.state.availabililtyTemplateModalShowing && <AvailabilityTemplateModal
              isVisible={this.state.availabililtyTemplateModalShowing}
              onClose={() => this.setState({ availabililtyTemplateModalShowing: false })}
              applyClick={(templateToApply) => this.setState({ templateToApply: templateToApply, availabililtyTemplateModalShowing: false })}
              selectedAgency={this.state.pagingGroupAgency}
            />}
            {this.state.viewByModalShowing && <ViewByModal
              viewByOptions={viewByOptions}
              isVisible={this.state.viewByModalShowing}
              onClose={() => this.setState({ viewByModalShowing: false })}
              backButton={() => this.setState({ viewByModalShowing: false })}
              selectedOption={this.state.viewByRange}
              applyButton={this.setViewByRange}
            />}
            {smallScreen &&
              <div className={styles.availabilityButtonContainer}>
                {addAvailabilityButton}
                {setPagingGroupDropDown}
                {saveButton}
                {ellipsesDropdown}
              </div>
            }
            <div className={styles.schedulerContainer}>
              {this.state.currentTab === copy.myAvailabilityScreen.myAvailability.title && (
                <MyScheduler
                  selectedAvailabilityType={this.state.selectedAvailabilityType}
                  selectedPagingGroups={this.state.pagingGroup}
                  showAvailabilityTypeModal={(eventId) => this.setState({ availabilityTypeModalShowing: true, eventId: eventId })}
                  popupButtons={!smallScreen && {
                    addAvailabilityButton: addAvailabilityButton,
                    setPagingGroupButton: setPagingGroupDropDown,
                    ellipsesDropdown: ellipsesDropdown,
                    saveButton: saveButton,
                  }
                  }
                  availabilityFormPayload={this.state.payload}
                  currentWidth={currentWidth}
                  viewByRange={this.state.viewByRange}
                  changeViewByRange={this.setViewByRange}
                  templateToApply={this.state.templateToApply}
                  updateChanges={this.updateChanges}
                  clearUncommittedChanges={this.state.clearUncommittedChanges}
                  uncommittedChangesCleared={this.uncommittedChangesCleared}
                  addNotchSafePadding={this.addNotchSafePadding}
                />
              )}
            </div>
          </>
        ) : (
          <div className={styles.noGroups}>{copy.myAvailabilityScreen.myAvailability.noGroups}</div>
        )}
      </div>
    );
  };

  renderDashboardViewMobile = (currentWidth, currentHeight) => {
    const smallScreen = currentWidth <= 666;
    const portrait = currentHeight / currentWidth > 1;
    const selectedType = this.state.selectedAvailabilityType;
    const pagingGroups = this.pagingGroupsPartOfWithAvailability;
    const userAgencies = this.props.userAgencies
      .filter((agency) => (agency !== 'DYNAMIC'))
    const defaultAgency = this.state.defaultPagingGroup ? this.state.defaultPagingGroup.agency : userAgencies[0];
    const setPagingGroupButton = <Button
      disabled={true}
      id="pagingGroupButton"
      styles={`${styles.setPagingGroupButtonClass}`}
      label={
        this.state.defaultPagingGroup
          ? this.state.defaultPagingGroup.agency +
          " - " +
          this.state.defaultPagingGroup.text
          : copy.myAvailabilityScreen.myAvailability.setPagingGroup
      }
      content={
        this.state.defaultPagingGroup ? (
          <div className={styles.setPagingGroupButtonContent}>
            {this.state.defaultPagingGroup.agency +
              " - " +
              this.state.defaultPagingGroup.text}
          </div>
        ) : (
          copy.myAvailabilityScreen.myAvailability.setPagingGroup
        )
      }
      variant="btn_myAvailabilityButs"
      icon="icon_arrowDownSmall"
    />
    const ellipsesIcon = <Icon
      icon="icon_ellipses"
    />
    const pasteIcon = <Icon
      icon="icon_paste"
    />
    const copyIcon = <Icon
      icon="icon_copy"
    />
    const chevronIcon = <Icon
      icon="icon_chevron_right"
    />
    const fullOptions = (portrait && this.state.width > 374) || (!portrait && this.state.width > 667);
    const ellipsesDropdownButton = <Button
      disabled={true}
      variant="btn_myAvailabilityButs"
      icon="icon_ellipsesDots"
      label="More options"
      content="More options"
    />
    const qualificationsButton = <Button
      variant="btn_myAvailabilityButs"
      icon="icon_arrowDownSmall"
      label="Qualifications"
      content="Qualifications"
      buttonClick={() => this.setState({ qualificationsFilterShowing: true })}
      ref={this.qualificationFilterRef}
    />
    const qualificationsToggle = <Toggle
      variant="toggle"
      smallToggle={true}
      checked={this.state.qualificationsToggle}
      buttonClick={() => this.setState({ qualificationsToggle: !this.state.qualificationsToggle })}
    />
    const setPagingGroupDropDown = (
      <SetPagingGroupDropdown
        userAgencies={userAgencies}
        pagingGroups={pagingGroups}
        setPagingGroupButton={setPagingGroupButton}
        defaultPagingGroup={this.state.defaultPagingGroup}
        defaultAgency={defaultAgency}
        smallScreen={smallScreen}
        selectPagingGroup={this.selectPagingGroup}
      />
    );
    const ellipsesDropdown =
      <Dropdown
        aria-label="Listbox menu"
        direction='left'
        trigger={(fullOptions) && ellipsesDropdownButton}
        icon={!(fullOptions) && ellipsesIcon}
        className={styles.dropdown + " ellipsesDropdownClass"}>
        <DropdownMenu className={styles.dropdownMenu + " ellipsesMenu"}>
          <DropdownHeader content="Options" className={styles.dropdownHeader} />
          <DropdownDivider />
          <DropdownItem
            onClick={() => this.setState(
              { sortByModalShowing: true }
            )}
            className={styles.dropdownItem}
          >
            Sort by
            {chevronIcon}
          </DropdownItem>
          {this.state.qualList?.length && <DropdownItem
            onClick={() => this.setState({ thresholdView: true })}
            className={styles.dropdownItem}
          >
            Threshold
            {chevronIcon}
          </DropdownItem>}
        </DropdownMenu>
      </Dropdown>
    const addAvailabilityButton = <Button
      label={copy.myAvailabilityScreen.myAvailability.addAvailability}
      content={`Availability • ${this.state.selectedAvailabilityTypes?.length || "0"}`}
      variant="btn_myAvailabilityButs"
      styles="dashboard"
      icon="icon_arrowDownSmall"
      buttonClick={() => this.setState({ availabilityTypeFilterShowing: true })}
      ref={this.availabilityFilterRef}
    />
    const qualificationsList = this.state.qualifications.filter(qual => qual?.agency === this.state.pagingGroupAgency).map(qual => {
      return (
        { key: qual?.id, value: qual?.name }
      )
    })
    const qualificationFavourites = this.state.qualificationFavourites
    const hasQualifications = qualificationsList.length > 0
    return (
      <div content={copy.myAvailabilityScreen.myAvailabilityDashboard}
        taburl={copy.taburls.myAvailabilityDashboard}
        style='tab-item-members'
      >
        {smallScreen &&
          <div className={styles.availabilityButtonContainer}>
            {addAvailabilityButton}
            {setPagingGroupDropDown}
            {ellipsesDropdown}
          </div>
        }
        {this.state.sortByModalShowing && <SortByModal
          isVisible={this.state.sortByModalShowing}
          onClose={() => this.setState({ sortByModalShowing: false })}
          backButton={() => this.setState({ sortByModalShowing: false })}
          selectedOption={this.state.sortByOption}
          selectedAvailabilityType={this.state.sortByType}
          AtoZ={this.state.sortByAtoZ}
          firstName={this.state.sortByFirstName}
          applyButton={this.applySortByOptions}
          availabilityTypes={copy.myAvailabilityScreen.agencyAvailabilityTypes[this.state.pagingGroupAgency]}
        />}
        {this.state.availabilityTypeFilterShowing && <AvailabilityTypeModal
          isVisible={this.state.availabilityTypeFilterShowing}
          onClose={() => this.setState({ availabilityTypeFilterShowing: false })}
          userAgency={defaultAgency}
          position={this.availabilityFilterRef.current.getBoundingClientRect()}
          closeDropdown={() => this.setState({ availabilityTypeFilterShowing: false })}
          singleSelect={false}
          onChange={(selectedAvailabilityTypes) => this.setState({ selectedAvailabilityTypes })}
          selectedAvailabilityTypes={this.state.selectedAvailabilityTypes}
        />}
        {this.state.qualificationsFilterShowing && <MultiSelectModal
          options={qualificationsList}
          favourites={qualificationFavourites}
          mainListTitle={copy.myAvailabilityScreen.membersAvailability.qualificationSubtitles.allQuals}
          secondaryListTitle={copy.myAvailabilityScreen.membersAvailability.qualificationSubtitles.favourites}
          isVisible={this.state.qualificationsFilterShowing}
          onClose={() => this.setState({ qualificationsFilterShowing: false })}
          position={this.qualificationFilterRef.current.getBoundingClientRect()}
          onChange={(selectedQualifications) => this.setState({ selectedQualifications })}
          selected={this.state.selectedQualifications}
        />}
        <div className={styles.schedulerContainer}>
          <MyDashboard
            selectedPagingGroups={this.state.pagingGroup}
            selectedPagingGroupName={this.state.pagingGroupName}
            selectedAvailabilityTypes={this.state.selectedAvailabilityTypes}
            selectedQualifications={this.state.selectedQualifications}
            qualificationsToggle={this.state.qualificationsToggle}
            sortByOption={this.state.sortByOption}
            sortByType={this.state.sortByType}
            sortByAtoZ={this.state.sortByAtoZ}
            sortByFirstName={this.state.sortByFirstName}
            width={this.state.width}
            height={currentHeight}
            qualificationFavourites={qualificationFavourites}
            hasQualifications={hasQualifications}
            qualifications={qualificationsList}
            popupButtons={!smallScreen ? {
              addAvailabilityButton: addAvailabilityButton,
              setPagingGroupButton: setPagingGroupDropDown,
              ellipsesDropdown: ellipsesDropdown,
              qualificationsButton: hasQualifications && qualificationsButton,
              qualificationsToggle: hasQualifications && qualificationsToggle,
            } : {
              qualificationsButton: hasQualifications && qualificationsButton,
              qualificationsToggle: hasQualifications && qualificationsToggle,
            }
            }
            addNotchSafePadding={this.addNotchSafePadding}
          />
        </div>

      </div>
    );
  };

  renderThresholdViewMobile = (currentWidth, currentHeight) => {
    let ownedGroups = []
    if (this.props.pagingGroupsOwned) {
      let agencies = Object.keys(this.props.pagingGroupsOwned)
      ownedGroups = agencies.flatMap(agency => this.props.pagingGroupsOwned[agency] || [])
      ownedGroups = ownedGroups.map(group => group?.key)
    }
    const smallScreen = currentWidth <= 666;
    const pagingGroups = this.pagingGroupsPartOfWithAvailability;
    const userAgencies = this.props.userAgencies
      .filter((agency) => (agency !== 'DYNAMIC' && agency !== 'AV'))
    const defaultAgency = this.state.defaultPagingGroup ? this.state.defaultPagingGroup.agency : userAgencies[0];
    const setPagingGroupButton = <Button
      disabled={true}
      id="pagingGroupButton"
      styles={`${styles.setPagingGroupButtonClass}` + " " + `${styles.wide}`}
      label={
        this.state.defaultPagingGroup
          ? this.state.defaultPagingGroup.agency +
          " - " +
          this.state.defaultPagingGroup.text
          : copy.myAvailabilityScreen.myAvailability.setPagingGroup
      }
      content={
        this.state.defaultPagingGroup ? (
          <div className={styles.setPagingGroupButtonContent}>
            {this.state.defaultPagingGroup.agency +
              " - " +
              this.state.defaultPagingGroup.text}
          </div>
        ) : (
          copy.myAvailabilityScreen.myAvailability.setPagingGroup
        )
      }
      variant="btn_myAvailabilityButs"
      icon="icon_arrowDownSmall"
    />
    const setPagingGroupDropDown = (
      <SetPagingGroupDropdown
        userAgencies={userAgencies}
        pagingGroups={pagingGroups}
        setPagingGroupButton={setPagingGroupButton}
        defaultPagingGroup={this.state.defaultPagingGroup}
        defaultAgency={defaultAgency}
        smallScreen={smallScreen}
        selectPagingGroup={this.selectPagingGroup}
      />
    );
    const qualificationThresholds = this.state.qualList?.map(qualPaging => {
      const qualification = qualPaging.qualification
      return (
        {
          key: qualification.id,
          value: qualification.name,
          thresholdCount: qualPaging.thresholdCount,
          orderValue: qualPaging.orderValue
        }
      )
    })
    const rolesWithSettingPermission = ["SuperUser", "Administrator", "Manager"]
    const ownsSelectedGroup = ownedGroups.includes(this.state.pagingGroup)
    const permissionToSetThresholds = this.props.userRoles?.
      reduce((acc, current) => acc || rolesWithSettingPermission.includes(current), false) || ownsSelectedGroup
    return (
      <div content={copy.myAvailabilityScreen.myAvailabilityDashboard}
        taburl={copy.taburls.myAvailabilityDashboard}
        style='tab-item-members'
      >
        <MembersThreshold
          exit={() => this.setState({ thresholdView: false })}
          qualifications={qualificationThresholds}
          pagingNumber={this.state.pagingGroup}
          pagingName={this.state.pagingGroupName}
          width={currentWidth}
          height={currentHeight}
          setPagingGroup={setPagingGroupDropDown}
          permissionToSetThresholds={permissionToSetThresholds}
        />
      </div>
    )
  }

  // Render tabs for mobile
  renderTabsMobile = (currentWidth, currentHeight) => {
    const isLoading = this.state.isLoading;
    if (!isLoading) {
      return (
        <Tabs
          showSlider={true}
          activeTab={this.state.currentTab}
          activeTabNumber={this.state.currentTabNumber}
          clickOnTab={this.handleTabClick}
          myAvailabilityTabClass={'myAvailabilityTabClass'}
        >
          {this.renderMyAvailabilityViewMobile(currentWidth, currentHeight)}
          {
            this.state.thresholdView ?
              this.renderThresholdViewMobile(currentWidth, currentHeight) :
              this.renderDashboardViewMobile(currentWidth, currentHeight)
          }
        </Tabs>
      );
    }
    else {
      return (
        <div className="loadingContainer">
          <Loader />
        </div>
      )
    }
  };

  render() {
    const isMobile = this.state.width <= 1023;
    const leavePageConfirmation = <LeavePageConfirmation
      when={this.state.uncommittedChanges.length > 0}
      save={this.saveChanges}
    />
    if (isMobile) {
      return (
        <Wrapper>
          {leavePageConfirmation}
          <ErrorBanner
            isVisible={this.state.errorMessage ? true : false}
            ErrorMessage={this.state.errorMessage}
            onTop={true}
          />
          <div
            className={
              "main-content-holder availability " + styles.availabilityWrapper
            }
          >
            {this.renderTabsMobile(this.state.width, this.state.height)}
          </div>
        </Wrapper>
      );
      // END THE MOBILE VERSION
    } else {
      // START THE DESKTOP VERSION
      return (
        <Wrapper>
          {leavePageConfirmation}
          <ErrorBanner
            isVisible={this.state.errorMessage ? true : false}
            ErrorMessage={this.state.errorMessage}
            onTop={true}
          />
          <div
            className={
              "main-content-holder availability " +
              styles.availabilityWrapper
            }
          >
            {this.renderTabsMobile(this.state.width, this.state.height)}
          </div>
        </Wrapper>
      );
    }
  }
}
